import React, { useContext, useEffect, useState } from 'react';
import { Button } from '@mui/material';
import styles from './styles.module.css';
import DataTable from 'components/utils/DataTable/';
import CreateDevicesDialog from 'components/popups/CreateDeviceDialog';
import CreateIcon from '@mui/icons-material/Create';
import RefreshIcon from '@mui/icons-material/Refresh';
import DeviceService from 'services/DeviceService';
import ConfirmPopup from 'components/utils/Alert/ConfirmPopup';
import Info from 'components/utils/Alert/Info';
import Error from 'components/utils/Alert/Error';
import Success from 'components/utils/Alert/Success';
import AlertHelper from 'helpers/AlertHelper';
import withConsoleBase from 'components/utils/ConsoleBase/withConsoleBase';
import { UserContext } from 'Context/UserContext';
import { USER_PERMISSIONS } from 'const';
import { useTranslation } from 'react-i18next';

function Devices() {
  const { t: tCommon } = useTranslation("common");
  const { t: tOperations } = useTranslation("operations");
  const { user } = useContext(UserContext);
  const [devices, setDevices] = useState('');
  const [addTab, setAddTab] = useState('');
  const [loadingIndicator, setLoadingIndicator] = useState(false);
  const [deleteData, setDeleteData] = useState('');
  const [errorMsg, setErrorMsg] = useState();
  const [successMsg, setSuccessMsg] = useState();

  const getDevices = async () => {
    setLoadingIndicator(true);
    try {
      const res = await DeviceService.getDevices();
      setDevices(
        res.map((device) => ({
          ...device,
          connection: device.connected_to ? 'online' : device.disconnected_at ? 'Disconnected' : 'N/A',
        }))
      );
    } catch (err) {
      AlertHelper.setShortMessage(setErrorMsg, err.message);
    }

    setLoadingIndicator(false);
  };
  const handleDeleteClick = (data) => {
    setDeleteData(data);
  };
  const handleDeviceDeletion = async (row) => {
    try {
      await DeviceService.deleteDevice(row.id);
      getDevices();
      AlertHelper.setShortMessage(setSuccessMsg, 'Device deleted successfully');
    } catch (err) {
      AlertHelper.setShortMessage(setErrorMsg, err.message);
    } finally {
      setDeleteData('');
    }
  };
  useEffect(() => {
    getDevices();
  }, []);
  const headerData = [
    {
      label: tCommon("Machine ID"),
      id: 'id',
      type: 'text',
    },
    {
      label: tCommon("Mac ID"),
      id: 'mac_id',
      type: 'text',
    },
    {
      label: tCommon("Machine Name"),
      id: 'machine_name',
      type: 'text',
    },
    {
      label: tCommon("Machine Number"),
      id: 'machine_number',
      type: 'text',
    },
    {
      label: tCommon("Machine Status"),
      id: 'connection',
      type: 'text',
    },
  ];
  if (((user || {}).shop_permissions || {}).devices_permission === USER_PERMISSIONS.WRITE) {
    headerData.push({
      label: tCommon("Delete"),
      title: 'Delete',
      id: 'delet',
      type: 'button',
      clickHandler: handleDeleteClick,
    });
  }
  const handleRefresh = () => {
    getDevices();
  };
  const toggleAddTab = () => {
    addTab ? setAddTab('') : setAddTab('open');
  };
  return (
    <div className={styles.contentWrapper}>
      <ConfirmPopup
        data={deleteData}
        handleClose={handleDeleteClick}
        handleOkay={handleDeviceDeletion}
        alertTitle={tCommon("Confirm Delete")}
        successBtnName={tCommon("Delete")}
        alertContent={tOperations("Delete device msg")}
      />
      <div className={styles.titleSec}>
        <h2 className={styles.title}>
          {tCommon("Devices")} <span className={styles.menuTitle}>{tCommon("list")}</span>
        </h2>
      </div>
      <div className={styles.changeable}>
        <div className={styles.filterSec}>
          <div className={styles.headTitle}>
            <h2 className={styles.subTitle}>{tCommon("Devices")}</h2>
          </div>
          <div className={styles.actionButtons}>
            {((user || {}).shop_permissions || {}).devices_permission === USER_PERMISSIONS.READ ? (
              ''
            ) : (
              <Button
                variant="contained"
                color="primary"
                className={styles.actionBtn}
                size="small"
                style={{ backgroundColor: '#605ca8' }}
                onClick={toggleAddTab}
              >
                <CreateIcon />
                {tOperations("Connect to")}
              </Button>
            )}
            <Button
              variant="contained"
              color="primary"
              size="small"
              className={styles.actionBtn}
              style={{ backgroundColor: '#00a65a' }}
              onClick={handleRefresh}
            >
              <RefreshIcon />
              {tOperations("Refresh devices status")}
            </Button>
          </div>
        </div>
      </div>
      {/* <DataTable
        columns={headerData}
        rows={devices}
        handleDeviceDeletion={handleDeviceDeletion}
      /> */}
      {errorMsg && (
        <div className={styles.marginTop}>
          <Error title={errorMsg} />
        </div>
      )}
      {successMsg && (
        <div className={styles.marginTop}>
          <Success title={successMsg} />
        </div>
      )}

      {((devices && devices[0]) || loadingIndicator) ? (
        <DataTable
          columns={headerData}
          rows={devices || []}
          isLoading={loadingIndicator}
          handleDeviceDeletion={handleDeviceDeletion}
        />
      ) : (
        !loadingIndicator && <Info title={tOperations('No device title')} content={tOperations('No device content')} />
      )}
      {addTab && (
        <CreateDevicesDialog toggleAddTab={toggleAddTab} setErrorMsg={setErrorMsg} setSuccessMsg={setSuccessMsg} />
      )}
    </div>
  );
}

export default withConsoleBase(Devices);
